import { ReactNode } from 'react'

import { Subheader, Text, Widget } from '@revolut-internal/ui-kit'

import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary'
import { FCWithChildren } from 'types'

type PageSectionProps = {
  title: string
  side?: ReactNode
}

export const PageSection: FCWithChildren<PageSectionProps> = ({
  title,
  side,
  children,
}) => {
  return (
    <Widget
      display="flex"
      style={{
        flexDirection: 'column',
      }}
      px="s-16"
      pb="s-16"
      height="100%"
    >
      <Subheader>
        <Subheader.Title>
          <Text variant="emphasis2" color="foreground">
            {title}
          </Text>
        </Subheader.Title>
        {side && <Subheader.Side>{side}</Subheader.Side>}
      </Subheader>

      <ErrorBoundary>{children}</ErrorBoundary>
    </Widget>
  )
}
